import { useEffect, useState, useRef } from "react";

const hasChanges = (initial, current) => {
  if (!initial || !current) return false;

  return JSON.stringify(initial) !== JSON.stringify(current);
};
const hasPropsChanges = (initial, current) => {
  const changes = {};
  Object.keys(initial).map(function (prop) {
    // console.log( "checkin prop"  +  prop );
    // console.log(  current[prop]);
    if (current.hasOwnProperty(prop) && initial[prop] != current[prop]) {
      // console.log( "Apply changes "  +  prop );
      changes[prop] = current[prop];
    }
  });
  return changes;
};
const useItemChanges = (initial, current) => {
  const refInitial = useRef();
  const refCurrent = useRef();

  const [changed, setChanged] = useState({});
  useEffect(() => {
    refInitial.current = initial;
    refCurrent.current = current;
    setChanged({});
    if (hasChanges(refInitial.current, refCurrent.current) === true) {
      setChanged(hasPropsChanges(refInitial.current, refCurrent.current));
    }
  }, [initial, current]);
  return changed;
};
export default useItemChanges;
